import * as yup from "yup";

import type { Translate } from "@shared/i18n/translationKey";
import type { RegisterRequestValues } from "../api/licenseApplicationApi";

/**
 * Schema factory del formulario de registro de solicitud. Se construye como
 * función para que los mensajes traducidos se resuelvan al momento de llamarla
 * (nunca definir schemas dentro del cuerpo del componente: se recrean en cada
 * render y no se pueden testear de forma aislada).
 *
 * @param t - función de traducción de i18next.
 */
export const buildRegisterRequestSchema = (t: Translate): yup.ObjectSchema<RegisterRequestValues> =>
  yup
    .object()
    .shape({
      supervisorEmail: yup.string().email(t("mailValid")).required(t("isRequired")),
      type: yup.string().typeError(t("isRequired")).required(t("isRequired")),
      startDate: yup.date().required(t("isRequired")),
      endDate: yup
        .date()
        .when("startDate", ([startDate], schema) =>
          startDate ? schema.min(startDate, t("endDateCannotBeforeStartDate")) : schema
        )
        .required(t("isRequired")),
      // El formulario ya enviaba `comments` pero el schema no lo declaraba, asi que quedaba
      // fuera de la forma validada. Se agrega sin restricciones: no cambia que se acepta,
      // solo hace que el tipo del schema coincida con lo que realmente se manda.
      comments: yup.string(),
    })
    .required();
